import { NgModule } from '@angular/core';
import { DotCMSEditablePageService } from '@dotcms/angular';

import { SharedModule } from 'ish-shared/shared.module';

import { DotCmsUveFooterComponent } from './shared/dot-cms-uve-footer/dot-cms-uve-footer.component';
import { DotCmsUveHeaderComponent } from './shared/dot-cms-uve-header/dot-cms-uve-header.component';
import { DotCmsUvePageComponent } from './shared/dot-cms-uve-page/dot-cms-uve-page.component';

@NgModule({
  imports: [DotCmsUveFooterComponent, DotCmsUveHeaderComponent, DotCmsUvePageComponent, SharedModule],
  declarations: [],
  exports: [SharedModule],
  providers: [DotCMSEditablePageService],
})
export class DotCmsUveModule {}
